module.exports = __webpack_public_path__ + "static/media/article11.4fa8c3a8.webp";